module.exports = __webpack_public_path__ + "static/media/3_mobile.7c0ae8dd.jpg";